import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { apiClient } from "~/api/ApiClient";
import { CenteredMessage } from "~/components/ui/centeredMessage/CenteredMessage";
import FullscreenLoader from "~/components/ui/loaders/FullscreenLoader";
import { FEATURE_FLAGS, useFeatureFlag } from "~/featureFlags";
import DashboardPage from "~/pages/dashboard/DashboardPage";
import { routes } from "~/router";

// load DashboardPage if a user has access
// otherwise try to redirect to first site main page (Duda case)
export function HomeRoute() {
  const nav = useNavigate();
  const dashboardEnabled = useFeatureFlag(FEATURE_FLAGS.SITES_DASHBOARD);

  const { data: sites, isLoading: isSitesLoading } = useQuery({
    enabled: !dashboardEnabled,
    queryKey: ["sites", "home-redirect"],
    queryFn: async () => {
      const res = await apiClient.sites.sitesList({
        "page[size]": 1,
        "page[number]": 1,
      });

      return res.data?.sites ?? [];
    },
  });

  const firstSiteId = useMemo(() => sites?.[0]?.id ?? null, [sites]);
  const siteFeatureEnabled = useFeatureFlag(FEATURE_FLAGS.SITES_ANALYTICS);

  useEffect(() => {
    if (dashboardEnabled) return;
    if (isSitesLoading) return;

    // has site and feature is enabled
    if (firstSiteId && siteFeatureEnabled) {
      nav(routes.site.root({ id: firstSiteId }), { replace: true });

      return;
    }
  }, [dashboardEnabled, isSitesLoading, firstSiteId, nav]);

  if (dashboardEnabled) return <DashboardPage />;

  if (isSitesLoading) {
    return <FullscreenLoader />;
  }

  return <CenteredMessage title="No Access" description="" />;
}
